var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowFold40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_713_938",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40.3174,
    width: 40,
    height: 40,
    transform: "rotate(-180 40 40.3174)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_713_938)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4526 15.5441C19.7549 15.2418 20.2451 15.2418 20.5474 15.5441L27.7732 22.7699C28.0756 23.0723 28.0756 23.5625 27.7732 23.8648C27.4709 24.1672 26.9807 24.1672 26.6784 23.8648L20 17.1865L13.3216 23.8648C13.0193 24.1672 12.5291 24.1672 12.2268 23.8648C11.9244 23.5625 11.9244 23.0723 12.2268 22.7699L19.4526 15.5441Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFold40);
export default __webpack_public_path__ + "static/media/arrow_fold_40.7a2b42bd832487da9502c4e7c3cf5ee6.svg";
export { ForwardRef as ReactComponent };